/*
 * NOTIFICATION CAMPAIGNS
 */

import { menuDefaultFilters } from "../../system/constants";
import { customerInfoDataType } from "../Customers/constants";

export const NOTIFICATION_CAMPAIGN_LIST = "notification_campaign_list";
export const NOTIFICATION_CAMPAIGN_STATISTICS_LIST =
  "notifications_campaign_statistics_list";
export const NOTIFICATION_CAMPAIGNS_URL = `brand/:brandId/notification-campaigns/`;
export const NOTIFICATION_CAMPAIGN_BY_ID_URL = `brand/:brandId/notification-campaigns/:campaignId`;
export const NOTIFICATION_CAMPAIGN_STATISTICS_URL = `brand/:brandId/notification-campaigns/:campaignId/messages`;
export const NOTIFICATION_CAMPAIGN_TEST_URL = `brand/:brandId/notification-campaigns/:campaignId/test`;
export const NOTIFICATION_CAMPAIGN_TEST_USERS_NUMBER = 10;
export const NOTIFICATION_CAMPAIGN_TEST_SEND_TIMEOUT = 119;
export const NOTIFICATION_CAMPAIGN_MAX_LIFETIME_DAYS = 30;

type userFilterType = {
  party_id?: string[];
  country?: string[];
  tag?: number[];
  vip_status?: string[];
};

export type notificationCampaignType = {
  id: number;
  brand_id: number;
  name: string;
  type: string;
  active: boolean;
  event: null | string;
  user_filters: userFilterType;
  category_id: null | number;
  important: boolean;
  allow_popup: boolean;
  push_enabled: boolean;
  start_sending_at: string | null;
  stop_sending_at: string | null;
  title: { [key: string]: string };
  description: {};
  short_description: {};
  button_text: {};
  button_color: {};
  image?: {};
  test_user_filters: userFilterType;
  button_url: {};
  created_at: string;
  updated_at: string;
};

export type fileUploaderDataType = {
  uploadFile?: (file) => void;
  uploadedFile?: any;
  isLoadingUploadFile?: boolean;
  cdnUrl?: string;
  setFieldValue: (field, value) => void;
  namespace?: string;
};

export type notificationCampaignStatisticsPropsType = {
  id: number;
  campaign_id: number;
  user_id: number;
  read_at: string;
  engaged_at: string | null;
  deleted_at: string | null;
  dismissed_at: string | null;
  created_at: string | null;
  updated_at: string;
  user: customerInfoDataType;
};

export type notificationCampaignStatisticsDataType = {
  total: number;
  count: number;
  per_page: number;
  current_page: number;
  total_pages: number;
  data: notificationCampaignStatisticsPropsType[];
};

export const notificationCampaignTypeOptions = [
  { value: "event_based", label: "Event based" },
  { value: "by_list", label: "By list" },
  { value: "general", label: "General" },
];

export const notificationCampaignEventOptions = [
  { value: "signed_up", label: "Registration" },
  { value: "kyc_verified", label: "KYC verified" },
  { value: "kyc_declined", label: "KYC Declined" },
  { value: "vip_assigned", label: "VIP assigned" },
  { value: "deposit_pending", label: "Deposit pending" },
  { value: "deposit_completed", label: "Deposit completed" },
  { value: "deposit_failed", label: "Deposit failed" },
  { value: "deposit_rejected", label: "Deposit rejected" },
  { value: "deposit_canceled", label: "Deposit canceled" },
  { value: "withdraw_pending", label: "Withdraw pending" },
  { value: "withdraw_completed", label: "Withdraw completed" },
  { value: "withdraw_failed", label: "Withdraw failed" },
  { value: "withdraw_rejected", label: "Withdraw rejected" },
  { value: "withdraw_canceled", label: "Withdraw canceled" },
];

export const notificationCampaignDescriptionFieldsConfig = {
  textInput: {
    fieldName: "title",
    label: "Title",
    placeholder: "Enter title",
    validationByLang: true,
  },
  extraTextInput: {
    fieldName: "short_description",
    label: "Short description",
    placeholder: "Enter short description",
    validationByLang: true,
  },
  textEditor: {
    fieldName: "description",
    label: "Description",
    validationByLang: true,
  },
  buttonSettings: {
    infoMessage: "If this field is empty - button is not appear",
    validationByLang: true,
  },
  imagesSettings: [
    {
      title: "Image",
      fieldName: "image",
      infoBox:
        "Suggested formats: .jpg, jpeg, png, gif, webp, bmp, svg, webm, mp4. Max size 1mb.",
    },
  ],
};

export const NOTIFICATION_CAMPAIGN_STATISTICS_DEBOUNCE_DELAY = 600;
export const NOTIFICATION_CAMPAIGN_STATISTICS_FULL_DATE_FORMAT =
  "HH:mm MMM d, yyyy";

export const notificationCampaignMessageTypeOptions = [
  { value: "read", title: "Read", id: "read" },
  { value: "received", title: "Received", id: "received" },
  { value: "deleted", title: "Deleted", id: "deleted" },
  { value: "dismissed", title: "Dismissed", id: "dismissed" },
];

export const notificationReceiversFileSizeLimit = 1024 * 1024;
export const notificationReceiversFileTypes = [
  "text/csv",
  "application/csv",
  "application/vnd.ms-excel",
];

export const notificationCampaignsDefaultFilter = {
  ...menuDefaultFilters,
};

export const DEFAULT_FILTER_VALUE = {
  state: { value: "true", fieldName: "active" },
};
